import { WS_URL } from "../../config.js";
import { state, patch } from "../../state/store.js";
import { handleSyncMessage } from "./handlers.js";

let socket = null;
let socketRetry = 0;
let socketRetryTimer = null;

export function connectSyncSocket() {
  if (!state.authToken) return;
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) return;
  try {
    socket = new WebSocket(`${WS_URL}?token=${encodeURIComponent(state.authToken)}`);
  } catch (err) {
    scheduleRetry();
    return;
  }
  patch({ connectionStatus: "syncing" });

  socket.addEventListener("open", () => {
    socketRetry = 0;
    patch({ connectionStatus: "connected" });
  });
  socket.addEventListener("message", (event) => {
    try {
      handleSyncMessage(JSON.parse(event.data));
    } catch (_) { /* noop */ }
  });
  socket.addEventListener("close", () => {
    socket = null;
    if (state.authToken) {
      patch({ connectionStatus: "offline" });
      scheduleRetry();
    }
  });
  socket.addEventListener("error", () => {
    try { socket?.close(); } catch (_) { /* noop */ }
  });
}

export function disconnectSyncSocket() {
  if (socketRetryTimer) {
    clearTimeout(socketRetryTimer);
    socketRetryTimer = null;
  }
  socketRetry = 0;
  if (socket) {
    try { socket.close(); } catch (_) { /* noop */ }
    socket = null;
  }
}

export function sendSocket(op, payload) {
  if (!socket || socket.readyState !== WebSocket.OPEN) return false;
  try {
    socket.send(JSON.stringify({ op, opId: createOpId(), payload }));
    return true;
  } catch (_) {
    return false;
  }
}

function scheduleRetry() {
  if (!state.authToken || socketRetryTimer) return;
  const delay = Math.min(30000, 1000 * Math.pow(2, socketRetry));
  socketRetry += 1;
  socketRetryTimer = setTimeout(() => {
    socketRetryTimer = null;
    connectSyncSocket();
  }, delay);
}

function createOpId() {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}
